export default "__VITE_ASSET__CrOsz5pJ__"